import { Identifiable } from 'app/armp/models/identifiable';

export class InformationType extends Identifiable<number> {
  name: string;
  code: string;
  defaultXsl: string;
}
